module.exports = __webpack_public_path__ + "assets/medkit.7e17fd68.svg";